import React from 'react';
import styled from '@emotion/styled';
import { POLAND_MAP_PATHS } from './polandMapPaths';
import { VoivodeshipId, VOIVODESHIP_NAMES } from './voivodeships';

const Svg = styled.svg`
  width: 100%;
  height: auto;
  display: block;
`;

const Region = styled.path`
  fill: #ffffff;
  stroke: #1ca039;
  stroke-width: 2;
  stroke-linejoin: round;
  stroke-miterlimit: 4;
  cursor: pointer;
  transition: fill 0.15s ease;

  &:hover,
  &[data-active='true'] {
    fill: #1ca039;
  }

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 2px solid #168030;
    outline-offset: 2px;
  }
`;

interface PolandMapSVGProps {
  activeId: VoivodeshipId | null;
  onRegionEnter: (id: VoivodeshipId) => void;
  onRegionClick: (id: VoivodeshipId) => void;
}

const PolandMapSVG: React.FC<PolandMapSVGProps> = ({
  activeId,
  onRegionEnter,
  onRegionClick,
}) => (
  <Svg viewBox="0 0 2061 1925" xmlns="http://www.w3.org/2000/svg">
    {POLAND_MAP_PATHS.map((path, index) => {
      const handleKeyDown = (event: React.KeyboardEvent<SVGPathElement>) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onRegionClick(path.id);
        }
      };
      return (
        <Region
          key={`${path.id}-${index}`}
          d={path.d}
          data-active={String(activeId === path.id)}
          role="button"
          tabIndex={0}
          aria-label={VOIVODESHIP_NAMES[path.id]}
          aria-pressed={activeId === path.id}
          onMouseEnter={() => onRegionEnter(path.id)}
          onFocus={() => onRegionEnter(path.id)}
          onClick={() => onRegionClick(path.id)}
          onKeyDown={handleKeyDown}
        />
      );
    })}
  </Svg>
);

export default PolandMapSVG;
